// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cross-sell[data-v-103f8b07]{padding:0;margin:0 0 -30px}.cross-sell.cross-sell--cart[data-v-103f8b07]{margin:0 -15px}@media (min-width:768px){.cross-sell[data-v-103f8b07]{padding:0;margin:0}.cross-sell.cross-sell--cart[data-v-103f8b07]{margin:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
